/* eslint-disable */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  login,
  logout,
  loginAdmin,
  loginEEntry,
  loginAdminEEntry,
  loginEDonation,
} from '../utils/functions/authMethod';
import { checkAccessRights } from '../utils/functions/accessRight';
import { ROLES } from '../utils/constants';
import { getSystem } from '../utils/functions/accessRight';

function AuthProvider({ children }) {
  const navigate = useNavigate();
  const handleSignin = async (email, password) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ');
    try {
      await login(email, password);
      window.location.reload();
    } catch (e) {
      throw new Error(e);
    }
  };

  const handleAdminSignin = async (email, password) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ');
    try {
      await loginAdmin(email, password);
      window.location.reload();
    } catch (e) {
      throw new Error(e);
    }
  };
  const handleEDonationSignin = async (email, password) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ');
    try {
      await loginEDonation(email, password);
      window.location.reload();
    } catch (e) {
      throw new Error(e);
    }
  };

  const handleSigninEEntry = async (email, password) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ');
    try {
      await loginEEntry(email, password);
      window.location.reload();
    } catch (e) {
      throw new Error(e);
    }
  };

  const handleAdminSigninEEntry = async (email, password) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ');
    try {
      await loginAdminEEntry(email, password);
      window.location.reload();
    } catch (e) {
      throw new Error(e);
    }
  };

  const handleSignout = async () => {
    console.log('[AuthContext] กำลังลงชื่อออก');
    const checkIsAdmin = checkAccessRights(ROLES.SUPER_ADMIN_ROLE);
    const System = getSystem();
    await logout();
    if (checkIsAdmin && System === 'ecashier') {
      navigate('/login-admin');
    } else if (checkIsAdmin && System === 'eentry') {
      navigate('/e-entry/login-admin');
    } else if (System === 'eentry') {
      navigate('/e-entry/login');
    } else {
      navigate('/login');
    }
  };

  return (
    <PassportAuth.Provider
      value={{
        handleSignin,
        handleAdminSignin,
        handleSignout,
        handleSigninEEntry,
        handleAdminSigninEEntry,
        handleEDonationSignin,
      }}
    >
      {children}
    </PassportAuth.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AuthProvider;
export const PassportAuth = React.createContext();
